<template>
  <div class="position-relative">
    <div class="more-info">
      <b-dropdown
        v-if="value"
        @show="showPatientData = true"
        @hide="showPatientData = false"
        id="dropdown-form"
        ref="dropdown"
        variant="link"
        size="sm"
        no-caret
        dropleft
        offset="-200"
        menu-class="dropdown-shadow"
      >
        <template #button-content>
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <a> More Patient Information</a>
        </template>
        <div class="position-relative">
          <eoc-picker-patient-data
            :eocId="value ? value.value : null"
            v-if="showPatientData"
          ></eoc-picker-patient-data>
          <div class="triangle-container">
            <div class="triangle-right"></div>
          </div>
        </div>
      </b-dropdown>
    </div>
    <v-select
      class="eoc-picker-control"
      :options="multiple ? filteredEocs : eocs"
      v-model="selectedValue"
      :placeholder="placeholder"
      :multiple="multiple ? multiple : false"
      @search="search"
      :filterable="!async"
    >
      <template #option="{ data }">
        <div class="d-flex flex-row align-items-start">
          <div class="w-100">
            <div v-if="data" class="d-flex flex-row align-items-center">
              <b-badge
                :variant="statusVariant(data.status)"
                class="text-white mr-1"
                >{{ statusText(data.status) }}
              </b-badge>
              <b-badge
                v-if="data.levelOfCare"
                :style="{ background: data.levelOfCare.color }"
                class="mr-1"
                >{{ data.levelOfCare?.name.substr(0, 3).toUpperCase() }}
              </b-badge>
              <span>{{ formatEocObj(data) }}</span>
            </div>
          </div>
        </div>
      </template>
      <template #selected-option="{ data }">
        <div class="d-flex flex-row w-100">
          <div v-if="data" class="w-100">
            <div class="d-flex flex-row align-items-center">
              <b-badge
                :variant="statusVariant(data.status)"
                class="text-white mr-1"
                >{{ statusText(data.status) }}
              </b-badge>
              <b-badge
                v-if="data.levelOfCare"
                :style="{ background: data.levelOfCare.color }"
                class="mr-1"
                >{{ data.levelOfCare?.name.substr(0, 3).toUpperCase() }}
              </b-badge>
              <span>{{ formatEocObj(data) }}</span>
            </div>
          </div>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import EocPickerPatientData from "../controls/EocPickerPatientData";

export default {
  name: "EocPicker",
  components: { EocPickerPatientData },
  props: ["eocs", "placeholder", "value", "multiple", "async"],
  data() {
    return {
      showPatientData: false
    };
  },
  methods: {
    search(search, loading) {
      if (this.async) this.$emit("search", { search, loading });
    },
    statusVariant(status) {
      switch (status) {
        case "Pending":
          return "warning";
        case "Active":
          return "success";
        case "Inactive":
          return "danger";
        default:
          return "";
      }
    },
    statusText(status) {
      return status.substring(0, 1);
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue ? newValue : null);
      }
    },
    filteredEocs() {
      if (this.multiple) {
        return this.selectedValue && this.selectedValue.length
          ? this.eocs.filter(
              eoc =>
                this.selectedValue.findIndex(o => o.value === eoc.value) < 0
            )
          : this.eocs;
      }

      return this.selectedValue
        ? this.eocs.filter(eoc => eoc.value != this.selectedValue.value)
        : this.eocs;
    }
  }
};
</script>

<style scoped>
.eoc-picker-control >>> .vs__selected {
  width: calc(100% - 19px);
}

.more-info {
  position: absolute;
  right: 0;
  top: -34px;
}

.eoc-picker-control >>> .vs__selected-options {
  flex-wrap: nowrap !important;
}

.dropdown-shadow {
  box-shadow: 0px 0px 20px 2px rgb(0 0 0 / 55%);
}
.triangle-right {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid rgba(0, 0, 0, 0.15);
  position: relative;
}

.triangle-right:before {
  content: "";
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-left: 9px solid white;
  position: absolute;
  top: -9px;
  right: 1px;
}
.triangle-container {
  position: absolute;
  right: -10px;
  top: 195px;
}
</style>
